import React from 'react'
import Heading from 'constructicon/heading'
import LoginForm from 'supporticon/components/login-form'

const Everydayhero = ({ buttonProps, onSuccess }) => (
  <div>
    <Heading>Login to your account</Heading>
    <LoginForm
      clientId={process.env.EDH_CLIENT_ID}
      formProps={{ submit: buttonProps }}
      onSuccess={onSuccess}
    />
  </div>
)

export default Everydayhero
